"use client";

import * as React from "react";
import { Facebook, Instagram } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col md:flex-row gap-4 items-center animate-pulse">
        <div className="h-4 w-20 bg-muted/20 rounded-md" />
        <div className="h-4 w-20 bg-muted/20 rounded-md" />
        <div className="h-4 w-20 bg-muted/20 rounded-md" />
        <div className="h-4 w-20 bg-muted/20 rounded-md" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col gap-4 md:flex-row md:gap-8 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group inline-flex h-auto w-auto items-center justify-center rounded-none bg-transparent p-0 text-sm font-medium text-muted-foreground transition-colors hover:bg-transparent hover:text-foreground focus:bg-transparent focus:text-foreground">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function FooterInformativo() {
  return;
}